// removed by extract-text-webpack-plugin
module.exports = {"border-radius-icon":"IconButton__border-radius-icon","borderRadiusIcon":"IconButton__border-radius-icon","cur-only":"IconButton__cur-only","curOnly":"IconButton__cur-only","nf-gray-bg-color":"IconButton__nf-gray-bg-color","nfGrayBgColor":"IconButton__nf-gray-bg-color","wf-cobalt-bg-color":"IconButton__wf-cobalt-bg-color","wfCobaltBgColor":"IconButton__wf-cobalt-bg-color","toltipbtn":"IconButton__toltipbtn","cir-disabled":"IconButton__cir-disabled","cirDisabled":"IconButton__cir-disabled","smtabarea":"IconButton__smtabarea","mdtabarea":"IconButton__mdtabarea"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/IconButton/IconButton.scss
// module id = 1776
// module chunks = 8